import React from 'react';
import '../styles/theme.css';
import '../styles/Extraction.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ExtractionStepRail from '../components/ExtractionStepRail';
import ExtractionResultPanel from '../components/ExtractionResultPanel';
import ExtractionRunPanel from '../components/ExtractionRunPanel';
/* IMPORTS */

function ExtractionPage() {
  return (
    <div className="ex-root">
      <div className="ex-layout-1">
        <div id="extractionnavbar" className="ex-slot-extractionnavbar">
          <Navbar activePage={"Extraction"} />
        </div>
        <div className="ex-layout-2">
          <div id="extractionsteprail" className="ex-slot-extractionsteprail">
            <ExtractionStepRail />
          </div>
          <div className="ex-layout-3">
            <div id="extractionrunpanel" className="ex-slot-extractionrunpanel">
              <ExtractionRunPanel />
            </div>
            <div id="extractionresultpanel" className="ex-slot-extractionresultpanel">
              <ExtractionResultPanel />
            </div>
          </div>
        </div>
        <div id="extractionfooter" className="ex-slot-extractionfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default ExtractionPage;